import { computed, observable } from 'mobx';
import { BaseBlock } from '~/models/blocks/base-block.model';
import { ITextBlockResponse } from '~/types/server.types';
import type { RootStore } from '~/stores/root.store';
import type { FlowRevision } from '~/models/flow-revision.model';
import { convertSmartFieldsToServerFormat } from '~/common/SmartFields/smart-fields.utils';

type TextBlockDataForServer = ReturnType<BaseBlock['getDataForServer']> &
    Pick<ITextBlockResponse, 'type' | 'content'>;

export class TextBlock extends BaseBlock {
    type: 'text_block';
    @observable content: string;

    constructor(
        block: ITextBlockResponse,
        flowRevision: FlowRevision<RootStore>,
        rootStore: RootStore
    ) {
        super(block, flowRevision, rootStore);
        this.type = block.type;
        this.content = block.content || '';
    }

    get isDeletable() {
        return true;
    }

    @computed
    get isEditingDisabled() {
        return this.isInsideLinkedCompanyInfoBlockInTemplate;
    }

    getDataForServer(): TextBlockDataForServer {
        return {
            ...super.getDataForServer(),
            type: this.type as 'text_block',
            content: convertSmartFieldsToServerFormat(this.content)
        };
    }
}
